/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { slug } from '../../../common';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.user`;

export default class Level extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const levelEnabled = app.forum.attribute(`${slug}.levels.enabled`);
		const levelShow = app.forum.attribute(`${slug}.levels.show`);

		if (!levelEnabled || !levelShow) {
			return null;
		}

		const { user } = this.attrs;

		return <div className="Level">{t(`${prfx}.level`, { level: user.level() })}</div>;
	}
}
